<template>
    <div class="formula-department-container" v-loading="loading">
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'">
            <div> -->
        <div class="content">
            <div class="tree-container">
                <me-tree
                    ref="myTree"
                    :treeData="data"
                    :treeLoading="treeLoading"
                    :treeToolBar="true"
                    :defaultProps="defaultUnitProps"
                    :defaultExpandedKeys="defaultCheckKeys"
                    :nodeKey="'tree_unit_id'"
                    :defaultExpandAll="true"
                    :showIcon="true"
                    :showIconKey="'node_expression'"
                    @handleTreeNodeClick="handleTreeNodeClick"
                    @handleAddTreeNode="handleAddTreeNode"
                    @handleEditTreeNode="handleEditTreeNode"
                    @handleDelTreeNode="handleDelTreeNode"
                ></me-tree>
            </div>
        </div>
        <!-- </div>
        </me-collapes> -->
        <div
            class="leader-tab power-tab right_container border-left"
            :style="{ width: width }"
        >000000000000000000000000000000000000
            <div class="point-tree">
                <me-tree
                    ref="myPointTree"
                    :treeData="pointData"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :defaultExpandedKeys="defaultPointCheckKeys"
                    :nodeKey="'point_id'"
                    :defaultExpandAll="false"
                    @handleTreeNodeClick="handlePointNodeClick"
                ></me-tree>
            </div>
            <div class="caculate-wrap">
                <div class="text-wrap">{{ node_expression_show }}</div>
                <div class="express-btn">
                    <div
                        class="express-item"
                        v-for="item in expreeBtns"
                        :key="item + 'i'"
                        @click="clickCaculateBtn(item)"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="btn-wrap">
                    <div class="btn-inner-wrap">
                        <div class="btn-clear" @click="resetExpress">清除</div>
                        <div class="btn-save" @click="saveExpress">保存</div>
                    </div>
                </div>
            </div>
        </div>
        <unit-dialog
            :dialogVisible.sync="unitVisible"
            :pUnitId="pUnitId"
            :treeUnitId="treeUnitId"
            :title="title"
            :unitName="unitName"
            :unit_id="selectTree.unit_id"
            @closeCb="closeUnitTree"
        ></unit-dialog>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import * as api from "@/http/api.js";
import {
    getTreeUnitList,
    delUnit,
    saveExpress,
    getTreeUnitById
} from "@/http/express/unit-express.js";
import UnitDialog from "./components/unit-dialog.vue";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "unit-dialog": UnitDialog
    },
    data() {
        return {
            data: [],
            pointData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultUnitProps: {
                children: "childList",
                label: "tree_unit_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            defaultPointCheckKeys: [],
            pointName: "",
            nodeKey: "point_id",
            width: "calc(100% - 370px)",
            node_expression_show: "",
            node_expression: "",
            point_ids: "",
            expreeBtns: [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                ".",
                "/",
                "(",
                ")",
                "*",
                "+",
                "-"
            ],
            unitVisible: false,
            pUnitId: "",
            treeUnitId: "",
            title: "新增部门",
            unitName: "",
            selectTree: {},
            loading: false
        };
    },
    mounted() {
        this.getTreeUnitList();
    },
    methods: {
        // 获取左侧部门树
        getTreeUnitList() {
            getTreeUnitList().then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    this.defaultCheckKeys = [
                        res.bus_json &&
                            res.bus_json[0] &&
                            res.bus_json[0].tree_unit_id
                    ];
                    this.$nextTick(() => {
                        if (this.selectTree.tree_unit_id) {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.selectTree.tree_unit_id
                            );
                            this.selectTree = this.$refs.myTree.$refs.tree.getCurrentNode();
                        } else {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.defaultCheckKeys[0]
                            );
                            this.selectTree = res.bus_json && res.bus_json[0];
                        }
                        this.getTreeUnitById();
                        this.getUnitPointList();
                    });
                }
            });
        },
        // 新增修改删除部门成功回调
        closeUnitTree() {
            this.pUnitId = "";
            this.treeUnitId = "";
            this.unitName = "";
            this.getTreeUnitList();
        },
        // 添加部门
        handleAddTreeNode(select) {
            this.pUnitId = this.selectTree.tree_unit_id;
            this.treeUnitId = "";
            this.title = "新增部门";
            this.unitName = "";
            this.unitVisible = true;
        },
        // 编辑部门
        handleEditTreeNode(select) {
            this.pUnitId = this.selectTree.p_tree_unit_id;
            this.treeUnitId = this.selectTree.tree_unit_id;
            this.unitName = this.selectTree.tree_unit_name;
            this.title = "编辑部门";
            this.unitVisible = true;
        },
        // 删除部门
        handleDelTreeNode(select) {
            this.pUnitId = this.selectTree.tree_unit_id;
            this.$confirm("确定删除此部门?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    delUnit({
                        tree_unit_id: this.pUnitId
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.selectTree = {};
                            this.closeUnitTree();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        // 点击部门树节点
        handleTreeNodeClick(select) {
            this.selectTree = select;
            this.node_expression_show = "";
            this.node_expression = "";
            this.point_ids = "";
            this.getTreeUnitById();
            this.getUnitPointList();
        },

        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function(obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.w_active == "0") {
                    //0 不让点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else {
                    // 1 让点
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            const param = {
                elec_customer_id: this.selectTree.elec_customer_id,
                point_class_id: "001"
            };
            console.log(111111111);
            console.log(param);
            api.getPointTree1(param).then(res => {
                if (res && res.error_code === "0") {
                    this.pointData = res.bus_json;
                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    this.defaultPointCheckKeys = [
                        formatData.firstPoint.point_id
                    ];
                }
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 56px)";
        },
        // 计算器按钮点击回调
        clickCaculateBtn(caculateBtn) {
            this.node_expression_show += caculateBtn;
            this.node_expression += caculateBtn;
        },
        handlePointNodeClick(select) {
            if (select.w_active == 1) {
                // 1 让点
                this.node_expression_show += select.point_name;
                this.node_expression += select.point_id;
                this.point_ids += select.point_id + ",";
            } else {
                // 0 不让点
                this.$message({
                    message: "此采集点没有w_active采集项",
                    type: "warning"
                });
            }
        },
        // 清除公式
        resetExpress() {
            this.$confirm("确定清除此公式?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.node_expression_show = "";
                    this.node_expression = "";
                    this.point_ids = "";
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        saveExpress() {
            this.loading = true;
            // node_expression_show: this.node_expression_show,
            saveExpress({
                tree_unit_id: this.selectTree.tree_unit_id,
                node_expression: this.node_expression,
                point_ids: this.point_ids.slice(0, this.point_ids.length - 1)
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.$message({
                        message: res.error_msg,
                        type: "success"
                    });
                    this.node_expression_show = "";
                    this.node_expression = "";
                    this.point_ids = "";
                    this.closeUnitTree();
                }
                this.loading = false;
            });
        },
        getTreeUnitById() {
            getTreeUnitById({
                tree_unit_id: this.selectTree.tree_unit_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.node_expression_show =
                        res.bus_json.node_expression_show || "";
                    this.node_expression = res.bus_json.node_expression || "";
                    this.point_ids = res.bus_json.point_ids || "";
                }
            });
        }
    }
};
</script>
<style lang="scss">
.formula-department-container {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    .content {
        .tree-container {
            width: px2Rem(280px);
            // border-right: 1px solid #b1c7dd;
            overflow-x: hidden;
            padding-right: 20px;
            box-sizing: border-box;
        }
    }
    .active-table {
        background: #ff7455 !important;
        // color: #fff !important;
        border-color: #ff7455 !important;
    }
    .tree-wrap {
        height: calc(100% - 10px);
        //  padding-top: 2.5rem;
        box-sizing: border-box;
        width: px2Rem(280px);
        padding-right: 20px;
    }
    .right_container {
        height: 100%;
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
        .caculate-wrap {
            width: calc(100% - 300px);
            height: 100%;
            overflow-y: auto;
            .text-wrap {
                width: 100%;
                min-height: 7rem;
                //border: 1px solid #56fcff;
                // @include border;
                border: 1px solid #56fcff;
                border-radius: 6px;
                // color: #56fcff;
                color: #fff;
                font-size: 1.2rem;
                line-height: 1em;
                padding: 0.6rem;
                box-sizing: border-box;
            }
            .express-btn {
                width: 36rem;
                margin-top: 20px;
                display: flex;
                flex-wrap: wrap;
                margin: 0 auto;
                margin-top: 2rem;
                .express-item {
                    margin-right: 1.4rem;
                    margin-bottom: 1.6rem;
                    width: 4rem;
                    height: 4rem;
                    background: linear-gradient(
                        -12deg,
                        #171533,
                        #063b7b,
                        #1e1837
                    );
                    // border: 1px solid #56fcff;
                    //    @include border;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    color: #00e1d4;
                    cursor: pointer;
                }
            }
            .btn-wrap {
                width: 36rem;
                margin: 0 auto;
                margin-top: 1rem;
                .btn-inner-wrap {
                    display: inline-flex;
                    margin-left: 2rem;
                }
                .btn-clear,
                .btn-save {
                    width: 8.5rem;
                    height: 2.2rem;
                    line-height: 2.2rem;
                    text-align: center;
                    font-size: 1rem;
                    color: #fff;
                    border-radius: 0.3rem;
                    cursor: pointer;
                }
                .btn-clear {
                    background: #8e9eab;
                    border: 1px solid #3d3d3d;
                    margin-right: 5rem;
                }
                .btn-save {
                    background: linear-gradient(-12deg, #073775, #5c0991);
                    border: 1px solid #3d3d3d;
                }
            }
        }
    }
    .border-left {
        // border-left: 1px solid #56fcff;
        //  @include border-left;
    }
    .point-tree {
        height: 100%;
    }
}
</style>
